import { render, staticRenderFns } from "./InfiniteScroller.vue?vue&type=template&id=06af9d1c&"
import script from "./InfiniteScroller.vue?vue&type=script&lang=js&"
export * from "./InfiniteScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports